import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/LoginView.vue'
import IndexView from '../views/Frame/IndexView.vue'
import MainView from '../views/Frame/MainView.vue'
import AdminListView from '../views/Frame/Admin/AdminListView.vue'
import ResaleListView from '../views/Frame/Resale/ResaleListView.vue'
import ResaleAllView from '../views/Frame/Resale/ResaleAllView.vue'
import CustomerListView from '../views/Frame/Customer/CustomerListView.vue'
import GradeListView from '../views/Frame/Grade/GradeListView.vue'
import ProductManagerView from '../views/Frame/Product/ProductManagerView.vue'
import ProductDistributeView from '../views/Frame/Product/ProductDistributeView.vue'
import ProductApplicationView from '../views/Frame/Product/ProductApplicationView.vue'
import ProductCategoryView from '../views/Frame/Product/ProductCategoryView.vue'
import ProductCategoryAllView from '../views/Frame/Product/ProductCategoryAllView.vue'
import ProductPreviewView from '../views/Frame/Product/ProductPreviewView.vue'
import ProductPreviewNewView from '../views/Frame/Product/ProductPreviewNewView.vue'
import ProductPreviewPrizeView from '../views/Frame/Product/ProductPreviewPrizeView.vue'
import ProductPreviewLowView from '../views/Frame/Product/ProductPreviewLowView.vue'
import ProductPreviewLow2View from '../views/Frame/Product/ProductPreviewLow2View.vue'
import CoinListView from '../views/Frame/Coin/CoinListView.vue'
import CategoryListView from '../views/Frame/Category/CategoryListView.vue'
import AddressListView from '../views/Frame/Address/AddressListView.vue'
import PermissionListView from '../views/Frame/Permission/PermissionListView.vue'
import LockListView from '../views/Frame/Lock/LockListView.vue'
import LockAllView from '../views/Frame/Lock/LockAllView.vue'
import OutListView from '../views/Frame/Out/OutListView.vue'
import SendListView from '../views/Frame/Send/SendListView.vue'
import NotifyListView from '../views/Frame/Notify/NotifyListView.vue'
import LogListView from '../views/Frame/Log/LogListView.vue'
import LogMemoListView from '../views/Frame/LogMemo/LogMemoListView.vue'
import ResaleAddView from '../views/Frame/Resale/ResaleAddView.vue'
import InventoryListView from '../views/Frame/Inventory/InventoryListView.vue'
import SettingListView from '../views/Frame/Setting/SettingListView.vue'
import DownloadListView from '../views/Frame/Download/DownloadListView.vue'
import BuyerListView from '../views/Frame/Buyer/BuyerListView.vue'
import ProductRemoveView from '../views/Frame/Product/ProductRemoveView.vue'
import ProductPrizeView from '../views/Frame/Product/ProductPrizeView.vue'
import ProductCustomerView from '../views/Frame/Product/ProductCustomerView.vue'

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 重写replace方法
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    children: [
      {
        path: '/',
        name: 'MainView',
        component: MainView
      },
      {
        path: '/Admin/List',
        name: 'AdminListView',
        component: AdminListView
      },
      {
        path: '/Resale/List',
        name: 'ResaleListView',
        component: ResaleListView
      },
      {
        path: '/Resale/All',
        name: 'ResaleAllView',
        component: ResaleAllView
      },
      {
        path: '/Customer/List',
        name: 'CustomerListView',
        component: CustomerListView
      },
      {
        path: '/Grade/List',
        name: 'GradeListView',
        component: GradeListView
      },
      {
        path: '/Product/Manager',
        name: 'ProductManagerView',
        component: ProductManagerView
      },
      {
        path: '/Product/Distribute',
        name: 'ProductDistributeView',
        component: ProductDistributeView
      },
      {
        path: '/Product/Application',
        name: 'ProductApplicationView',
        component: ProductApplicationView
      },
      {
        path: '/Product/Category',
        name: 'ProductCategoryView',
        component: ProductCategoryView
      },
      {
        path: '/Product/CategoryAll',
        name: 'ProductCategoryAllView',
        component: ProductCategoryAllView
      },
      {
        path: '/Product/Preview',
        name: 'ProductPreviewView',
        component: ProductPreviewView
      },
      {
        path: '/Product/PreviewNew',
        name: 'ProductPreviewNewView',
        component: ProductPreviewNewView
      },
      {
        path: '/Product/PreviewPrize',
        name: 'ProductPreviewPrizeView',
        component: ProductPreviewPrizeView
      },
      {
        path: '/Product/PreviewLow',
        name: 'ProductPreviewLowView',
        component: ProductPreviewLowView
      },
      {
        path: '/Product/PreviewLow2',
        name: 'ProductPreviewLow2View',
        component: ProductPreviewLow2View
      },
      {
        path: '/Coin/List',
        name: 'CoinListView',
        component: CoinListView
      },
      {
        path: '/Category/List',
        name: 'CategoryListView',
        component: CategoryListView
      },
      {
        path: '/Send/List',
        name: 'SendListView',
        component: SendListView
      },
      {
        path: '/Address/List',
        name: 'AddressListView',
        component: AddressListView
      },
      {
        path: '/Permission/List',
        name: 'PermissionListView',
        component: PermissionListView
      },
      {
        path: '/Lock/List',
        name: 'LockListView',
        component: LockListView
      },
      {
        path: '/Lock/All',
        name: 'LockAllView',
        component: LockAllView
      },
      {
        path: '/Out/List',
        name: 'OutListView',
        component: OutListView
      },
      {
        path: '/Notify/List',
        name: 'NotifyListView',
        component: NotifyListView
      },
      {
        path: '/Log/List',
        name: 'LogListView',
        component: LogListView
      },
      {
        path: '/LogMemo/List',
        name: 'LogMemoListView',
        component: LogMemoListView
      },
      {
        path: '/Resale/Add',
        name: 'ResaleAddView',
        component: ResaleAddView
      },
      {
        path: '/Inventory/List',
        name: 'InventoryListView',
        component: InventoryListView
      },
      {
        path: '/Setting/List',
        name: 'SettingListView',
        component: SettingListView
      },
      {
        path: '/Download/List',
        name: 'DownloadListView',
        component: DownloadListView
      },
      {
        path: '/Buyer/List',
        name: 'BuyerListView',
        component: BuyerListView
      },
      {
        path: '/Product/Remove',
        name: 'ProductRemoveView',
        component: ProductRemoveView
      },
      {
        path: '/Product/Prize',
        name: 'ProductPrizeView',
        component: ProductPrizeView
      },
      {
        path: '/Product/Customer',
        name: 'ProductCustomerView',
        component: ProductCustomerView
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
